"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Accordion.scss");
var _collapseCloseGold = _interopRequireDefault(require("../../images/collapse-close-gold.svg"));
var _collapseCloseBlue = _interopRequireDefault(require("../../images/collapse-close-blue.svg"));
var _collapseOpenGold = _interopRequireDefault(require("../../images/collapse-open-gold.svg"));
var _collapseOpenBlue = _interopRequireDefault(require("../../images/collapse-open-blue.svg"));
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/formatSpecialCharText"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _BoundedCardLinkIcon = require("../BoundedCard/BoundedCardLinkIcon");
var _CTASectionMethods = require("../CTASection/CTASectionMethods");
var _LinkListMethods = require("../LinkList/LinkListMethods");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const AccordionItem = _ref => {
  let {
    item,
    iconColor,
    theme,
    disableIcon,
    setVisible
  } = _ref;
  const [isExpanded, setIsExpanded] = (0, _react.useState)(false);
  const [itemBodyHeight, setItemBodyHeight] = (0, _react.useState)("0");
  const dividerColor = theme?.darkTheme ? iconColor : "#D1D2D8";
  const accordionBodyRef = (0, _react.useRef)(null);
  const accordionSubheadRef = (0, _react.useRef)(null);
  const accordionLinkRef = (0, _react.useRef)(null);
  const handleExpandedAccordion = () => {
    setIsExpanded(!isExpanded);
  };
  const openIcon = () => {
    return theme?.darkTheme ? _collapseOpenGold.default : _collapseOpenBlue.default;
  };
  const closeIcon = () => {
    return theme?.darkTheme ? _collapseCloseGold.default : _collapseCloseBlue.default;
  };
  (0, _react.useEffect)(() => {
    if (typeof window !== "undefined") {
      setItemBodyHeight(isExpanded ? accordionBodyRef?.current?.offsetHeight + accordionSubheadRef?.current?.offsetHeight + accordionLinkRef?.current?.offsetHeight + 32 + "px" : "0");
    }
  }, [isExpanded]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `luna-accordion__item ${isExpanded ? "luna-accordion__item--open" : ""}`,
    style: {
      borderBottom: `1px solid ${dividerColor}`
    },
    "data-expanded": isExpanded,
    "data-sb-object-id": item?.contentfulId ? item?.contentfulId : null
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "luna-accordion__item-header",
    onClick: () => handleExpandedAccordion()
  }, !disableIcon && item?.icon && /*#__PURE__*/_react.default.createElement("div", {
    className: "luna-accordion__item-header-icon"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: `luna-accordion__item-header-icon-type`,
    size: "48px",
    type: item?.icon,
    color: iconColor,
    sbProps: item?.contentfulId ? {
      "data-sb-field-path": "textItemIcon"
    } : null
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-sb-field-path": item?.contentfulId ? "headline" : null,
    className: "luna-accordion__item-header-text",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(item?.headline)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "luna-accordion__item-header-collapse"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "luna-accordion__item-header-collapse-type",
    src: isExpanded ? openIcon() : closeIcon(),
    alt: "collapse icon"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: `luna-accordion__item-wrapper ${item?.icon && " luna-accordion__item-wrapper--has-icon"}`,
    style: {
      maxHeight: itemBodyHeight
    }
  }, /*#__PURE__*/_react.default.createElement("h3", {
    ref: accordionSubheadRef,
    className: `luna-accordion__item-subheader--${theme?.theme}`,
    "data-sb-field-path": item?.contentfulId ? "subhead" : null
  }, item?.subheader), /*#__PURE__*/_react.default.createElement("div", {
    "data-sb-field-path": item?.contentfulId ? "body" : null,
    ref: accordionBodyRef,
    className: `luna-accordion__item-body 
              ${disableIcon || !item?.icon && "luna-accordion__item-body--full "}
              luna-accordion__bullet-theme--${theme?.theme}
              `,
    dangerouslySetInnerHTML: {
      __html: item?.body
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: accordionLinkRef
  }, /*#__PURE__*/_react.default.createElement(_LinkListMethods.SingleLink, {
    contentfulId: item?.link?.contentfulId,
    key: item?.link?.contentfulId,
    linkText: item?.link?.text,
    destination: item?.link?.url,
    theme: theme,
    Link: item?.link?.Link,
    video: item?.link?.video,
    onClick: item?.link?.onClick,
    setVisible: setVisible
  }))));
};
var _default = AccordionItem;
exports.default = _default;
AccordionItem.propTypes = {
  item: _propTypes.default.object,
  iconColor: _propTypes.default.string,
  theme: _propTypes.default.string,
  disableIcon: _propTypes.default.bool
};